<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" [config]="{ backdrop: 'static', keyboard: false}">
    <div class="spinner-container">
        <span class="spinner-icon">
            <i class="fas fa-sync fa-spin"></i>
        </span>
        <span class="spinner-label">
            executando...
        </span>
    </div>
</div>